<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Helpers
	import { get_local_ip, real_id } from '../../../../../helpers/interface_helpers';
	//Services
	import { localReq, postReq } from '../../../../../services/http';
	import { format } from '../../../../../services/i18n';
	//Stores
		//Design system components
	import { Button, Radio, toast } from '@Shelly/shelly-design-system';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	$: settingsStore = getDeviceSettings(device.id);
	export let device;

	const types = ['on', 'off', 'last'];

	const defaultOptionsLegacy = [
		$format('power_on_default_on', {
			default: 'On: this {device.category} device will turn on, when it has power.',
		}),
		$format('power_on_default_off', {
			default: 'Off: this {device.category} device will turn off, when it has power.',
		}),
		$format('power_on_default_last', {
			default: 'Restore last mode: this {device.category} device will use its latest mode.',
		}),
	];

	const defaultOptionsNewLayout = [
		{
			title: $format('power_on_default_on_new_layout_title', {
				default: 'Turn on',
			}),
			description: $format('power_on_default_on_new_layout_description', {
				default: 'Automatically turns the device on when power is restored.',
			}),
		},
		{
			title: $format('power_on_default_off_new_layout_title', {
				default: 'Turn off',
			}),
			description: $format('power_on_default_off_new_layout_description', {
				default: 'Keeps the device off when power is restored.',
			}),
		},
		{
			title: $format('power_on_default_last_new_layout_title', {
				default: 'Restore last state',
			}),
			description: $format('power_on_default_last_new_layout_description', {
				default: 'Returns the device to its previous state when power is restored.',
			}),
		},
	];
	let settings = $settingsStore;

	let selected =
		settings[device.category !== 'emeter' ? device.category + 's' : 'relays'][
			device.category !== 'emeter' ? device.channel : 0
		].default_state;

	let cache = selected;

	let loading = false;

	let localIp = get_local_ip(device.id);

	const setDefault = (state) => {
		selected = state;
	};

	const sentRequest = async () => {
		if (cache !== selected) {
			let res;
			loading = true;
			if (localIp) {
				res = await localReq(
					device,
					`${localIp}/settings/${
						device.category === 'roller' ? 'relay/roller' : device.category
					}/${device.channel}`,
					'post',
					{
						default_state: selected,
					},
				);
			} else {
				res = await postReq(
					`device/${device.category !== 'emeter' ? device.category : 'relay'}/settings/default_state`,
					{
						channel: device.category !== 'emeter' ? device.channel : 0,
						state: selected,
						id: real_id(device.id),
					},
				);
			}
			if (res.isok) {
				settings[device.category + 's'][
					device.category !== 'emeter' ? device.channel : 0
				].default_state = selected;
				toast.open({
					type: 'success',
					title:
						$format('power_on_default_scc_toast') || `Power on was changed to ${selected}.`,
				});
				devices_settings.update_devices_settings(device.id, settings);
				cache = selected;
			} else {
				toast.open({ type: 'danger', title: $format('error_global') });
				selected = cache;
			}
			loading = false;
		}
	};
</script>

{#if $showNewLayout}
	{#each types as _type, i}
		<Radio
			class="mb-s"
			size="m"
			{selected}
			value={_type}
			on:click={() => setDefault(_type)}
			id={`power-on-${_type}`}
			info={defaultOptionsNewLayout[i].description}
		>
			{defaultOptionsNewLayout[i].title}
		</Radio>
	{/each}
{:else}
	{#each types as _type, i}
		<Radio
			class="mb-s"
			size="m"
			{selected}
			value={_type}
			on:click={() => setDefault(_type)}
			id={`power-on-${_type}`}
		>
			{defaultOptionsLegacy[i]}
		</Radio>
	{/each}
{/if}

<Button class={$showNewLayout ? 'mt-m' : 'mt-s'} {loading} size="m" width="full" on:click={sentRequest}>
	{$format('button_save')}
</Button>
